import { Box, Text } from '@chakra-ui/react';
import { CardCarousel, Grid } from '@time-line/components/common';
import type { Testimonial as TestimonialType } from 'types/cms/blocks/TestimonialGroup';

import { Testimonial } from './Testimonial';

interface TestimonialsCarouselProps {
  testimonials: TestimonialType[];
  title?: string;
}

export function TestimonialsCarousel({
  title,
  testimonials,
}: TestimonialsCarouselProps) {
  return (
    <Box className="section--testimonials-carousel" my="2xl">
      {title && (
        <Grid>
          <Grid.Inner gridRowGap={0}>
            <Box gridColumn="span 12">
              <Text as="h2" size="h2">
                <Text as="span" size="overline" display="block" mb="3xs">
                  Recommended by
                </Text>
                <Text as="span" size="h2" display="block">
                  {title}
                </Text>
              </Text>
            </Box>
          </Grid.Inner>
        </Grid>
      )}
      <CardCarousel
        mt="sm"
        buttonVerticalOffset="30%"
        sx={{
          // HACK: Firefox renders backdrop-filter as solid white inside this 3D layer
          '@supports (-moz-appearance: none)': {
            '.swiper-backface-hidden .swiper-slide': {
              transform: 'none',
              backfaceVisibility: 'visible',
            },
          },
        }}
        swiperBreakpoints={{
          0: {
            slidesPerView: 1.15,
            spaceBetween: 12,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          960: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 24,
          },
        }}
      >
        {testimonials.map((testimonial, index2) => (
          <Testimonial
            className={`testimonial-${index2 + 1}`}
            key={index2}
            testimonial={testimonial}
          />
        ))}
      </CardCarousel>
    </Box>
  );
}
